module.exports = __webpack_public_path__ + "img/qw_wel.36aa459a.png";